import { render, staticRenderFns } from "./DefferedUrgentSwitch.vue?vue&type=template&id=453d4aeb&scoped=true&"
import script from "./DefferedUrgentSwitch.vue?vue&type=script&lang=js&"
export * from "./DefferedUrgentSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d4aeb",
  null
  
)

export default component.exports